import React from 'react';
import Button from '@components/atoms/Button';
import ArrowRightIcon from '@components/atoms/icons/ArrowRightIcon';

export const InternalButton = ({
  title,
  descendants,
  isOpen = false,
  onClick = () => {}
}) => {
  return (
    <Button
      m="4"
      ml="2"
      cursor="pointer"
      role="menuitem"
      pointerEvents="auto"
      rightIcon={<ArrowRightIcon color="primary.froneri-blue" h="5" w="5" />}
      opacity={isOpen ? `1` : `0`}
      transition={`opacity 0.05s ease-in ${descendants.length * 0.05}s`}
      onClick={onClick}>
      {title}
    </Button>
  );
};
